import {Component, OnInit} from '@angular/core';
import {User} from '../../../models/user.model';
import {UserService} from '../../../services/user.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ChangeModalComponent } from './change-modal/change-modal.component';
import { AdminService } from '../../../services/admin.service';
import { Router } from '@angular/router';
import {
  GeneralSetting,
  GeneralSettingEditableField,
  mergeGeneralSetting,
} from '../../../models/general-setting.model';

type SettingsSection = '' | 'standarts' | 'suggestions' | 'lerning' | 'tasks' | 'vacation' | 'karma' | 'ai';

interface GeneralSettingViewField {
  action: GeneralSettingEditableField;
  labelKey: string;
  modalTitleKey: string;
}

@Component({
  selector: 'app-view-user-report',
  templateUrl: './view-user-report.component.html',
  styleUrls: ['./view-user-report.component.css']
})
export class ViewUserReportComponent implements OnInit {
  public readonly aiSettings: GeneralSettingViewField[] = [
    this.createSettingField('testRetakeCooldownHours', 'TEST_RETAKE_COOLDOWN_HOURS'),
    this.createSettingField(
      'testGenerationLimitPerUserPerSpecializationPerDay',
      'TEST_GENERATION_LIMIT_PER_USER_PER_SPECIALIZATION_PER_DAY',
    ),
    this.createSettingField('chatMaxOutputTokens', 'CHAT_MAX_OUTPUT_TOKENS'),
    this.createSettingField(
      'testGenerationMaxOutputTokens',
      'TEST_GENERATION_MAX_OUTPUT_TOKENS',
    ),
    this.createSettingField('maxChatMessageLength', 'MAX_CHAT_MESSAGE_LENGTH'),
    this.createSettingField('chatHistoryMessageLimit', 'CHAT_HISTORY_MESSAGE_LIMIT'),
    this.createSettingField('chatMessagesPerUserPerDay', 'CHAT_MESSAGES_PER_USER_PER_DAY'),
    this.createSettingField(
      'chatMessagesPerUserPerMinute',
      'CHAT_MESSAGES_PER_USER_PER_MINUTE',
    ),
    this.createSettingField('perUserDailyTokenLimit', 'PER_USER_DAILY_TOKEN_LIMIT'),
    this.createSettingField('globalDailyTokenLimit', 'GLOBAL_DAILY_TOKEN_LIMIT'),
  ];

  private user: User;
  userAPI;
  public isLoaded = false;
  public errorInfo = false;
  isAdmin = false;
  host;
  isAdmins = false;
	isUser = false;
	isHead = false;
  visible: SettingsSection = '';
  obj: GeneralSetting = mergeGeneralSetting(null);
  suc = false;

  constructor(private userService: UserService,
              private modalService: NgbModal,
                private router: Router,
              private adminService: AdminService) {
                this.host = location.origin;;
              }
  

  ngOnInit() {
    this.isAdmin = false;
    this.user = this.userService.getLocal();

    this.userService.getUserFromAPI(this.user.id).subscribe(
      (response) => {
        const data = response.body;
        this.userAPI = data;

        this.userAPI.roles.forEach(role => {
          if (role === 'ADMIN') {
            this.isAdmin = true;
          }
        });

        this.isLoaded = true;
        this.errorInfo = false;

      },
      () => {
        this.isLoaded = true;
        this.errorInfo = true;
      },
      () => {
     
      });

      this.user = this.userService.getLocal();
      if (this.user.roles.indexOf('ROLE_ADMIN') !== -1) {
        this.isAdmins = true;
      } else {
        this.isAdmins = false;
      }
      if (this.user.roles.indexOf('ROLE_HEAD') !== -1) {
        this.isHead = true;
      } else {
        this.isHead = false;
      }
      if (this.user.roles.indexOf('ROLE_USER') !== -1) {
        this.isUser = true;
      } else {
        this.isUser = false;
      }

      if(!this.isAdmins) {
        this.router.navigate(['/dashboard']);
      }

      this.renameGroup();
  }


  renameGroup() {
    this.adminService.getModalSetting().subscribe(
        (res) => {
          this.obj = mergeGeneralSetting(res.body);
        },
        () => {
          this.obj = mergeGeneralSetting(this.obj);
        }
      );
  }

  openEdit(action: GeneralSettingEditableField, title: string, value: number) {
    const modalRef = this.modalService.open(ChangeModalComponent);
    modalRef.componentInstance.action = action;
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.obj = this.obj;
    modalRef.componentInstance.value = value;
    modalRef.result.then((result) => {
			if (result === 'ok') {
        this.suc = true;
				setTimeout(() => this.suc = false, 2000);
				this.renameGroup();
			}
		});
  }

  vis(action: SettingsSection) {
    this.visible = action;
  }

  getSettingValue(action: GeneralSettingEditableField): number {
    return this.obj[action];
  }

  trackBySettingAction(index: number, field: GeneralSettingViewField): string {
    return field.action;
  }

  private createSettingField(
    action: GeneralSettingEditableField,
    labelKey: string,
  ): GeneralSettingViewField {
    return {
      action,
      labelKey,
      modalTitleKey: 'SET_VALUE_IN_UNITS',
    };
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/views/view-user-report/view-user-report.component.ts